import { useCallback } from "react";
import useContent from "../../../../../hooks/useContent";

/**
 * Text for the X10 Configuration tab. Contentful entries `outletDetails.x10_config_<key>` win; until they exist the
 * English fallback is shown.
 */
const useConfigurationText = () => {
  const { outletDetails } = useContent();

  return useCallback(
    (key: string, fallback: string) => outletDetails[`x10_config_${key}`] || fallback,
    [outletDetails]
  );
};

export default useConfigurationText;
